
import { ProjectView } from "@/views/project-view";
import { Component, Inject } from "vue-property-decorator";

@Component
export default class extends ProjectView {
    /// private helpers
    // get infSystem() {
    //     return require("raw-loader!./interfaces/system.read.interface").default;
    // }
    // /// private helpers
    // get infRead() {
    //     return require("raw-loader!./interfaces/log.read.interface").default;
    // }
    // get serverR() {
    //     return {
    //         path: "/log",
    //         params: {
    //             orderBy: [
    //                 {
    //                     createdAt: "desc",
    //                 },
    //             ],
    //         },
    //     };
    // }
}
